import React from 'react';

const ReactionsPopoverBg: React.FC = () => {
    return (
        <svg width="142" height="51" viewBox="0 0 142 51">
            <g filter="url(#filter0_d)">
                <path
                    d="M4 16.8767C4 7.55596 11.556 0 20.8767 0H121.123C130.444 0 138 7.55596 138 16.8767C138 26.1975 130.444 33.7534 121.123 33.7534H96.779C89.7607 33.7534 82.9143 35.9253 77.1795 39.9711L75.0452 41.4768C72.9141 42.9802 70.056 42.9348 67.9738 41.3645L66.9696 40.6072C61.0715 36.1594 53.8852 33.7534 46.498 33.7534H20.8767C11.556 33.7534 4 26.1975 4 16.8767Z"
                    fill="white"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d"
                    x="0"
                    y="0"
                    width="142"
                    height="50.574"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
};

export default ReactionsPopoverBg;
